import Vue from 'vue';
import { CrudPanel, CrudTable } from '@mee4dy/crud/dist/ui/vue';
import '@mee4dy/crud/dist/ui/vue/style.css';

Vue.use(CrudPanel);
Vue.use(CrudTable);
